import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import { CFG_STEP_COPY, resolveStepCopy } from '../../lib/configuratorStepCopy';

type Props = {
  show: boolean;
  stepKey?: keyof typeof CFG_STEP_COPY;
  /** selector_schema / option_schema с блоком step_copy из админки */
  schema?: Record<string, unknown> | null;
  children: ReactNode;
  className?: string;
};

export function ConfiguratorReveal({ show, stepKey, schema, children, className = 'mb-5' }: Props) {
  if (!show) return null;
  const copy = stepKey ? resolveStepCopy(stepKey, schema) : null;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.38, ease: [0.16, 1, 0.3, 1] }}
    >
      {copy && (
        <motion.div
          className="mb-4 rounded-2xl px-4 py-3.5"
          style={{
            background: 'rgba(255,255,255,0.06)',
            border: '1px solid var(--border-subtle)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.06, duration: 0.28 }}
        >
          <p className="text-sm font-semibold flex items-center gap-2" style={{ color: 'var(--text-1)' }}>
            <span className="text-base" aria-hidden>{copy.icon}</span>
            {copy.title}
          </p>
          <p className="text-xs mt-1.5 leading-relaxed" style={{ color: 'var(--text-3)' }}>
            {copy.hint}
          </p>
        </motion.div>
      )}
      {children}
    </motion.div>
  );
}
